// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calendar-container {
  width: 350px;
  height: 330px;
  text-align: center;
  background: #00468c;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.calendar-wrapper {
  position: relative;
  height: 100%;
  background: #f2f2f2;
  border-radius: 8px;
}

.react-calendar {
  height: 100%;
  background: #f2f2f2;
}

.react-calendar__navigation {
  height: 20%;
}
.react-calendar__navigation__arrow {
  width: 20%;
  font-size: xx-large;
  color: #00468c;
}
.react-calendar__navigation__label {
  font-size: 1.5rem;
  font-weight: bold;
  pointer-events: none;
  color: #00468c;
}

.react-calendar__month-view__weekdays {
  font-size: 0.9rem;
  border: none;
  color: #00468c;
  margin-top: 2%;
}

.react-calendar__tile {
  position: relative;
  padding: 3%;
  font-size: medium;
  font-weight: lighter;
}

.tile-tooltip-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  z-index: 3;
  cursor: pointer;
}

.react-calendar__tile abbr {
  position: relative;
  z-index: 5;
  pointer-events: none;
  color: #000;
  font-weight: bold;
}

.sunday-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  right: 10px;
  background-color: #fc4f4f;
  z-index: 4;
}

.holiday-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  right: 10px;
  z-index: 4;
}

.optional-dot {
  background-color: #fc4f4f;
}

.company-dot {
  background-color: #9090fd;
}

.react-tooltip {
  z-index: 9999 !important;
  background-color: #000000e6 !important;
  color: white !important;
  padding: 6px 10px !important;
  border-radius: 5px !important;
  font-size: 14px !important;
}

.react-calendar__tile--active {
  background-color: #fae5a4 !important;
  border-radius: 5px;
}

.react-calendar__tile--range {
  background-color: #fae5a4 !important;
}
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd {
  background-color: #fae5a4 !important;
}

.holiday-legend-top {
  position: absolute;
  top: 65px;
  left: 27%;
  transform: translateX(-50%);
  display: flex;
  gap: 1rem;
  background-color: transparent;
  border-radius: 5px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.color-box {
  width: 12px;
  height: 12px;
  border-radius: 2px;
}

.color-box.optional {
  background-color: #fc4f4f;
}

.color-box.company {
  background-color: #9090fd;
}
`, "",{"version":3,"sources":["webpack://./src/components/HolidayCalendar/HolidayCalendar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,sCAAsC;EACtC,uBAAuB;EACvB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;AACA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".calendar-container {\n  width: 350px;\n  height: 330px;\n  text-align: center;\n  background: #00468c;\n  padding: 10px;\n  border-radius: 10px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n\n.calendar-wrapper {\n  position: relative;\n  height: 100%;\n  background: #f2f2f2;\n  border-radius: 8px;\n}\n\n.react-calendar {\n  height: 100%;\n  background: #f2f2f2;\n}\n\n.react-calendar__navigation {\n  height: 20%;\n}\n.react-calendar__navigation__arrow {\n  width: 20%;\n  font-size: xx-large;\n  color: #00468c;\n}\n.react-calendar__navigation__label {\n  font-size: 1.5rem;\n  font-weight: bold;\n  pointer-events: none;\n  color: #00468c;\n}\n\n.react-calendar__month-view__weekdays {\n  font-size: 0.9rem;\n  border: none;\n  color: #00468c;\n  margin-top: 2%;\n}\n\n.react-calendar__tile {\n  position: relative;\n  padding: 3%;\n  font-size: medium;\n  font-weight: lighter;\n}\n\n.tile-tooltip-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: transparent;\n  z-index: 3;\n  cursor: pointer;\n}\n\n.react-calendar__tile abbr {\n  position: relative;\n  z-index: 5;\n  pointer-events: none;\n  color: #000;\n  font-weight: bold;\n}\n\n.sunday-dot {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  right: 10px;\n  background-color: #fc4f4f;\n  z-index: 4;\n}\n\n.holiday-dot {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  right: 10px;\n  z-index: 4;\n}\n\n.optional-dot {\n  background-color: #fc4f4f;\n}\n\n.company-dot {\n  background-color: #9090fd;\n}\n\n.react-tooltip {\n  z-index: 9999 !important;\n  background-color: #000000e6 !important;\n  color: white !important;\n  padding: 6px 10px !important;\n  border-radius: 5px !important;\n  font-size: 14px !important;\n}\n\n.react-calendar__tile--active {\n  background-color: #fae5a4 !important;\n  border-radius: 5px;\n}\n\n.react-calendar__tile--range {\n  background-color: #fae5a4 !important;\n}\n.react-calendar__tile--rangeStart,\n.react-calendar__tile--rangeEnd {\n  background-color: #fae5a4 !important;\n}\n\n.holiday-legend-top {\n  position: absolute;\n  top: 65px;\n  left: 27%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 1rem;\n  background-color: transparent;\n  border-radius: 5px;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.color-box {\n  width: 12px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.color-box.optional {\n  background-color: #fc4f4f;\n}\n\n.color-box.company {\n  background-color: #9090fd;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
